module.exports = __webpack_public_path__ + "static/media/mainProstitution.3193f6e2.jpg";